define('modules/editor/models/property_groups/background',['require','exports','module','./base','env','lib/util'],function(require,exports,module){
  "use strict";
  var BasePropertyGroup = require("./base"),
      config = require("env"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    /**
       NOTE
       In order to produce cross-browser gradients, we can't
       add the styles inline, as a bunch of vendor
       specific prefixes is needed.

       We can solve it creating a new CSS Class for each element
       using this property, and add all vendor-specific code to
       that CSS .class. Howver, with elements lacking ID or CLASS
       properties in the current version, we must find some value
       unique to each element to name the CSS class after it.

       The common "applyStyles" method thus is not valid, as don't
       intend to style the "element" but the page itself. We
       need an alternative.

    **/
    name: "background",
    properties: [
      "type", //solid | gradient
      "color", //#hex or rgba value for alpha
      "opacity", //0 to 10
      "imageUrl", //imageUrl
      "backgroundPosition", //background-image horizontal position
      "backgroundRepeat", //x, y, both or no
      "secondColor", //for gradient
      "direction", //gradient: to right, to bottom, to bottom right
    ],
    //can be overriden by element property defaults
    defaults: {
      type: "solid",
      color: "#eeeeee",
      opacity: 10,
      imageUrl: "",
      backgroundPosition: "center center",
      backgroundRepeat: "repeat",
      secondColor: "#999999",
      direction: "to right"
    },
    _getColor: function(key) {
      key = key || "color";
      if(this.get(key).indexOf("#") === 0){
        return util.hexToRgba(this.get(key), this.get("opacity")/10);
      }
      else {
        return this.get(key);
      }
    },
    generateStyles: function($el, id, klass) {
      var color = this._getColor(),
          styles = {};
      if (this.get("type") === "solid") {
        _.extend(styles, {
          "background-color": this._getColor(),
          "background-image": this._getBgImage(),
          "background-position": this._getBgPosition(),
          "background-repeat": this._getBgRepeat(),
        });
      } else {
        _.extend(styles, {
          "background": this._getColor() + " " + this._getGradient()
        });
      }
      return [{ selector: "#" + id, rules: styles }];
    },
    _getBgImage: function() {
      return this.get("imageUrl") && this.get("imageUrl") !== "none" ? this._generateImagePath() : "";
    },
    _getBgPosition: function() {
      return this.get("backgroundPosition");
    },
    _getBgRepeat: function() {
      return this.get("backgroundRepeat");
    },
    _getGradient: function() {
      var gradDirection = this.get("direction");
      return "linear-gradient(" + gradDirection + ", " + this._getColor() +
        ", " + this._getColor("secondColor") + ")";
    },
    _generateImagePath: function(){
      return "url(\"" + config.apiHost.replace("https:", "") + "/img/assets/" + this.get("imageUrl") + "\")";
    }
  });
});

